const SearchIcon = (props) => (
  <svg width="17" height="16" viewBox="0 0 17 16" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1894_780)">
    <path d="M12.5208 11.0779L15.3762 13.9326L14.4328 14.8759L11.5782 12.0206C10.516 12.8721 9.19483 13.3352 7.8335 13.3333C4.5215 13.3333 1.8335 10.6453 1.8335 7.33325C1.8335 4.02125 4.5215 1.33325 7.8335 1.33325C11.1455 1.33325 13.8335 4.02125 13.8335 7.33325C13.8354 8.69459 13.3723 10.0157 12.5208 11.0779ZM11.1835 10.5833C12.0296 9.71318 12.5021 8.54687 12.5002 7.33325C12.5002 4.75459 10.4115 2.66659 7.8335 2.66659C5.25483 2.66659 3.16683 4.75459 3.16683 7.33325C3.16683 9.91125 5.25483 11.9999 7.8335 11.9999C9.04712 12.0018 10.2134 11.5293 11.0835 10.6833L11.1835 10.5833Z" fill="#616778"/>
    </g>
    <defs>
    <clipPath id="clip0_1894_780">
    <rect width="16" height="16" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
  </svg>
);

export default SearchIcon;
